import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';

import { GetDefaultVideo, GetEvent } from '../helpers/ConfigApi';

import Banner from '../components/layout/Banner';
import VideoPlayer from '../components/video/VideoPlayerJS';
import Vods from '../components/vods/Vods';
import Tabs from '../components/tabs/Tabs';

const useStyles = makeStyles(theme => ({
  gold: {
    color: '#fff',
    backgroundPosition: 'center top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: '#98866c',
    paddingBottom: '500px',
    [theme.breakpoints.down('md')]: {
      paddingBottom: '250px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '125px',
    },
  },
  player: {
    marginTop: '-500px',
    [theme.breakpoints.down('md')]: {
      marginTop: '-250px',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '-125px',
    },
  },
  container: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  title: {
    fontWeight: '300',
    color: '#fff'
  },
  eventdate: {
    fontWeight: 400,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    paddingTop: theme.spacing(1)
  },
  button: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
  },
  notFound: {
    paddingTop: theme.spacing(20),
    textAlign: 'center'
  },
}));

export default (props) => {
  const history = useHistory();

  const { id } = props.match.params;
  const event = useMemo(() => GetEvent(props.config, id), [props.config, id])
  const defaultVideo = useMemo ( () => GetDefaultVideo(event), [event] );

  const [playerSrc, setPlayerSrc] = useState(defaultVideo);
  const [childSrc, setChildSrc] = useState(playerSrc);

  useEffect(() => {
    setPlayerSrc(childSrc);
  }, [childSrc]);
  const updateVideoFromChild = (vod) => {
    setChildSrc(vod);
  }

  useEffect(() => {
    // if the player is currently playing the default video
    // reload it, if the defaultVideo has been changed,
    // or a video src has been updated in the config file
    if (playerSrc && event && event.content && event.content.videos) {
      for (let i = 0; i < event.content.videos.length; i++) {
        if (playerSrc.id === event.content.videos[i].id) {
          setChildSrc(defaultVideo);
        }
      }
    }
  }, [playerSrc, event, defaultVideo]);

  const classes = useStyles();
  return (
    <>
    <div className={classes.gold} style={{ backgroundImage: `url('/background.gold.jpg')` }}>
      <Banner isAuthenticated={props.isAuthenticated} Logout={props.Logout} />
      <Container>
        {!event &&
          <div className={classes.notFound}>
            <h3>Loading ... </h3>
            <div className={classes.button}><Button color="primary" variant="contained" onClick={() => history.push('/')}>return to event page</Button></div>
          </div>
        }
        { event &&
        <div className={classes.container}>
          <div><h2 className={classes.title}>Australian Engineering Excellence Awards <strong>{event.name}</strong></h2></div>
          <div><h5 className={classes.eventdate}>{event.eventtime}, {event.eventdate}</h5></div>
        </div>
        }
      </Container>
    </div>
    <div className={classes.player}>
      <Container>
        { playerSrc &&
          <VideoPlayer src={playerSrc} userId={props.user.attributes.email} />
        }
        {
          event && event.content.vods && event.content.vods.length > 0 &&
          <Vods config={event} UpdateVideoSrc={updateVideoFromChild} />
        }
        {
          event && event.content.tabs && event.content.tabs.length > 0 &&
          <Tabs config={event} />
        }
      </Container>
    </div>
    </>
  );
}
